<template>
  <window :window-id="windowId">
    <window-tab :title="windowTitle">
      <switch-buttons :template-id="templateId"></switch-buttons>
      <div class="form-group form-row">
        <label :for="safeId('title1')" class="col-sm-4 col-form-label">Team 1</label>
        <div class="col-sm-8">
          <input type="text" class="form-control" :id="safeId('title1')" v-model.lazy="title1">
        </div>
      </div>
      <div class="form-group form-row">
        <label :for="safeId('title2')" class="col-sm-4 col-form-label">Team 2</label>
        <div class="col-sm-8">
          <input type="text" class="form-control" :id="safeId('title2')" v-model.lazy="title2">
        </div>
      </div>
      <div class="form-group form-row">
        <label :for="safeId('sets1')" class="col-sm-4 col-form-label">Sets 1</label>
        <div class="col-sm-4">
          <input type="number" class="form-control" :id="safeId('sets1')" v-model.lazy="sets1">
        </div>
        <div class="col-sm-2">
          <button class="btn btn-primary btn-block" @click="addSets('sets1', -1)">-</button>
        </div>
        <div class="col-sm-2">
          <button class="btn btn-primary btn-block" @click="addSets('sets1', 1)">+</button>
        </div>
      </div>
      <div class="form-group form-row">
        <label :for="safeId('sets2')" class="col-sm-4 col-form-label">Sets 2</label>
        <div class="col-sm-4">
          <input type="number" class="form-control" :id="safeId('sets2')" v-model.lazy="sets2">
        </div>
        <div class="col-sm-2">
          <button class="btn btn-primary btn-block" @click="addSets('sets2', -1)">-</button>
        </div>
        <div class="col-sm-2">
          <button class="btn btn-primary btn-block" @click="addSets('sets2', 1)">+</button>
        </div>
      </div>
      <div class="form-group form-row">
        <label :for="safeId('games1')" class="col-sm-4 col-form-label">Games 1</label>
        <div class="col-sm-4">
          <input type="number" class="form-control" :id="safeId('games1')" v-model.lazy="games1">
        </div>
        <div class="col-sm-2">
          <button class="btn btn-primary btn-block" @click="addGames('games1', -1)">-</button>
        </div>
        <div class="col-sm-2">
          <button class="btn btn-primary btn-block" @click="addGames('games1', 1)">+</button>
        </div>
      </div>
      <div class="form-group form-row">
        <label :for="safeId('games2')" class="col-sm-4 col-form-label">Games 2</label>
        <div class="col-sm-4">
          <input type="number" class="form-control" :id="safeId('games2')" v-model.lazy="games2">
        </div>
        <div class="col-sm-2">
          <button class="btn btn-primary btn-block" @click="addGames('games2', -1)">-</button>
        </div>
        <div class="col-sm-2">
          <button class="btn btn-primary btn-block" @click="addGames('games2', 1)">+</button>
        </div>
      </div>
      <div class="form-group form-row">
        <label :for="safeId('points2')" class="col-sm-6 col-form-label">Game / Tiebreak</label>
        <div class="col-sm-3">
          <button class="btn btn-block"
                  :class="[tiebreak !== '1' ? 'btn-warning' : 'btn-secondary']" @click="setTiebreak('0')">Game
          </button>
        </div>
        <div class="col-sm-3">
          <button class="btn btn-block"
                  :class="[tiebreak === '1' ? 'btn-danger' : 'btn-secondary']" @click="setTiebreak('1')">Tiebreak
          </button>
        </div>
      </div>
      <div class="form-group form-row">
        <label :for="safeId('points1')" class="col-sm-4 col-form-label">Points 1</label>
        <div class="col-sm-4">
          <input type="number" class="form-control" :id="safeId('points1')" v-model.lazy="points1">
        </div>
        <div class="col-sm-2">
          <button class="btn btn-primary btn-block" @click="add('points1', -1)">-</button>
        </div>
        <div class="col-sm-2">
          <button class="btn btn-primary btn-block" @click="add('points1', 1)">+</button>
        </div>
      </div>
      <div class="form-group form-row">
        <label :for="safeId('points2')" class="col-sm-4 col-form-label">Points 2</label>
        <div class="col-sm-4">
          <input type="number" class="form-control" :id="safeId('points2')" v-model.lazy="points2">
        </div>
        <div class="col-sm-2">
          <button class="btn btn-primary btn-block" @click="add('points2', -1)">-</button>
        </div>
        <div class="col-sm-2">
          <button class="btn btn-primary btn-block" @click="add('points2', 1)">+</button>
        </div>
      </div>
      <div class="form-group form-row">
        <label :for="safeId('points2')" class="col-sm-6 col-form-label">Service</label>
        <div class="col-sm-2">
          <button class="btn btn-block"
                  :class="[service === '0' ? 'btn-primary' : 'btn-secondary']" @click="setService('0')">0
          </button>
        </div>
        <div class="col-sm-2">
          <button class="btn btn-block"
                  :class="[service === '1' ? 'btn-primary' : 'btn-secondary']" @click="setService('1')">1
          </button>
        </div>
        <div class="col-sm-2">
          <button class="btn btn-block"
                  :class="[service === '2' ? 'btn-primary' : 'btn-secondary']" @click="setService('2')">2
          </button>
        </div>
      </div>
    </window-tab>
    <window-tab title="Settings" icon="cog">
      <template-settings :templateId="templateId"></template-settings>
    </window-tab>
  </window>
</template>

<script>
  import { templateMixin } from '@/mixins'
  import { mapOverlayData } from '../../utils/index'
  import * as action from '../../store/action-types'

  export default {
    name: 'tennis-scoreboard',
    mixins: [templateMixin],
    computed: {
      ...mapOverlayData(['title1', 'title2', 'sets1', 'sets2', 'games1', 'games2', 'points1', 'points2', 'tiebreak', 'service'])
    },
    methods: {
      addSets (id, value) {
        this.games1 = '0'
        this.games2 = '0'
        this.points1 = '0'
        this.points2 = '0'
        this.tiebreak = '0'
        this.add(id, value, {games1: 0, games2: 0, points1: 0, points2: 0, tiebreak: 0})
      },
      addGames (id, value) {
        this.points1 = '0'
        this.points2 = '0'
        this.tiebreak = '0'
        this.add(id, value, {points1: 0, points2: 0, tiebreak: 0})
      },
      add (id, value, data) {
        this[id] = '' + ((parseInt(this[id]) || 0) + value)
        data = data || {}
        data[id] = this[id]
        this.$store.dispatch(action.OVERLAY_DATA, {
          templateId: this.templateId,
          channelIds: ['program', 'preview'],
          data
        })
      },
      setTiebreak (value) {
        this.points1 = '0'
        this.points2 = '0'
        this.tiebreak = value
        this.$store.dispatch(action.OVERLAY_DATA, {
          templateId: this.templateId,
          channelIds: ['program', 'preview'],
          data: {'points1': 0, 'points2': 0, 'tiebreak': value}
        })
      },
      setService (value) {
        this.service = value
        this.$store.dispatch(action.OVERLAY_DATA, {
          templateId: this.templateId,
          channelIds: ['program', 'preview'],
          data: {'service': value}
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/templates/tennis-scoreboard.vue